import { useBoundStore } from '@/stores/root';
import { Button, chakra, Heading } from '@chakra-ui/react';
import { useEffect } from 'react';
import { msalInstance } from './authConfig';
import { useTranslation } from 'react-i18next';

const Wrap = chakra('div', {
  base: {
    display: 'flex',
    flexDir: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    margin: 'auto',
    maxWidth: '500px',
  },
});

export const Logout = () => {
  const clearUser = useBoundStore((state) => state.planner.user.clear);

  useEffect(() => {
    msalInstance.clearCache();
    clearUser();
  }, []);

  const { t } = useTranslation('translation', { keyPrefix: 'user.logoutView' });

  // Use window.location here to avoid msal redirecting back to this page
  return (
    <Wrap>
      <Heading>{t('title')}</Heading>
      <Button mt="2" size="small" onClick={() => (window.location.pathname = '/')}>
        {t('logbackIn')}
      </Button>
    </Wrap>
  );
};
